export default __webpack_public_path__ + "static/media/lateral_raise_start.6ecd75fd.svg";